import { configureStore } from '@reduxjs/toolkit'
import reducer from 'redux/reducer'
import { createWrapper } from 'next-redux-wrapper'
import sessionStorageMiddleware from './storage/sessionStorage'

// ✅ Esto es lo que next-redux-wrapper necesita: una función que devuelva un store
const makeStore = () => configureStore({
  reducer,
  devTools: process.env.NODE_ENV !== 'production',
  preloadedState: {},
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(sessionStorageMiddleware),
})

// ✅ Ahora sí: le pasas la función a createWrapper
export const wrapper = createWrapper(makeStore)

// import { configureStore } from '@reduxjs/toolkit'
// import { createWrapper } from 'next-redux-wrapper'
// import reducer from 'redux/reducer' // Ajusta el path según sea necesario

// // Opciones base para configurar el store
// const options = {
//   reducer,
//   devTools: process.env.NODE_ENV !== 'production',
// }

// // Configuración para middlewares en desarrollo
// if (process.env.NODE_ENV !== 'production') {
//   options.middleware = (getDefaultMiddleware) => getDefaultMiddleware()
// }

// // Función para inicializar el store
// export const makeStore = (context) => {
//   // Puedes acceder a `context` si es necesario (p.ej., para SSR)
//   return configureStore(options)
// }

// // Crea un wrapper para Redux
// export const wrapper = createWrapper(makeStore, {
//   debug: process.env.NODE_ENV !== 'production',
//   serializeState: (state) => JSON.stringify(state),
//   deserializeState: (state) => JSON.parse(state),
// })
